<template>
  <div>
    <order-buy-method-item
        v-for="(buyMethod, idx) in buyMethods"
        :key="idx"
        :buy-method="buyMethod"
        v-bind="$attrs"
        @change="handleChange"
        v-on="$listeners"/>
  </div>
</template>

<script>
import OrderBuyMethodItem from "@/components/OrderDialog/OrderBuyMethodItem";
export default {
  name: "OrderBuyMethods",
  props: {
    buyMethods: Array
  },
  methods: {
    handleChange(type) {
      this.buyMethods.forEach(item => {
        if(item.type != type)
          item.value = undefined;
      })
      this.$emit("change")
    },
  },
  components: {OrderBuyMethodItem}
}
</script>

<style scoped>

</style>